﻿$(function () {

    BindCalendars();
});

// Til brug for updatepanels så kalenderne bliver bundet igen efter partiel postback
$(document).ready(function () {
    try {
        if (typeof Sys === "undefined") {
            // do nothing
        }
        else {
            // Sys is something
            Sys.WebForms.PageRequestManager.getInstance().add_endRequest(EndRequestHandler);
            function EndRequestHandler() {
                BindCalendars();
            }
        }
    } catch (e) {

    }
});

function BindCalendars() {
    var datefield = document.createElement("input");
    datefield.setAttribute("type", "date");

    //if (datefield.type != "date") { /* chrome fejler når man ønsker et andet format end US i datoer.. derfor er det slået fra... */
        $(".datePicker").datepicker(
           {
               /*dateFormat: 'yy-mm-dd',
               dayNames: ['Søndag', 'Mandag', 'Tirsdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lørdag'],
               dayNamesShort: ['Søn', 'Man', 'Tir', 'Ons', 'Tor', 'Fre', 'Lør'],
               dayNamesMin: ['Sø', 'Ma', 'Ti', 'On', 'To', 'Fr', 'Lø'],
               monthNames: ['Januar', 'Februar', 'Marts', 'April', 'Maj', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'December'],
               monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],*/
               /*dateFormat: 'dd-mm-yy',*/
               constrainInput: true,
               firstDay: 1,
               showWeek: true,
               changeYear: true,
               changeMonth: true,
               /*weekHeader: 'Uge',*/
               yearRange: '2013:+36',
               beforeShow: function () {
                   setTimeout(function () {
                       $('.ui-datepicker').css('z-index', 99999999999999);
                   }, 0);
                },
               altFormat: 'yy-mm-dd'
           });
        //Sætter dato til dato fra input
        $(".datePickerDynamic").datepicker(
                    {
                        /*dateFormat: 'yy-mm-dd',
                        dayNames: ['Søndag', 'Mandag', 'Tirsdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lørdag'],
                        dayNamesShort: ['Søn', 'Man', 'Tir', 'Ons', 'Tor', 'Fre', 'Lør'],
                        dayNamesMin: ['Sø', 'Ma', 'Ti', 'On', 'To', 'Fr', 'Lø'],
                        monthNames: ['Januar', 'Februar', 'Marts', 'April', 'Maj', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'December'],
                        monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],*/
                        dateFormat: 'dd-mm-yy',
                        constrainInput: true,
                        firstDay: 1,
                        showWeek: true,
                        changeYear: true,
                        changeMonth: true,
                        /*weekHeader: 'Uge',*/
                        yearRange: '2013:+36',
                        beforeShow: function () {
                            setTimeout(function () {
                                $('.ui-datepicker').css('z-index', 99999999999999);
                            }, 0);
                        }
                    });
        $(".birthdayDatePicker").datepicker(
               {
                   /*dateFormat: 'yy-mm-dd',
                   dayNames: ['Søndag', 'Mandag', 'Tirsdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lørdag'],
                   dayNamesShort: ['Søn', 'Man', 'Tir', 'Ons', 'Tor', 'Fre', 'Lør'],
                   dayNamesMin: ['Sø', 'Ma', 'Ti', 'On', 'To', 'Fr', 'Lø'],
                   monthNames: ['Januar', 'Februar', 'Marts', 'April', 'Maj', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'December'],
                   monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],*/
                   /*dateFormat: 'dd-mm-yy',*/
                   constrainInput: true,
                   firstDay: 1,
                   showWeek: true,
                   changeYear: true,
                   changeMonth: true,
                   /*weekHeader: 'Uge',*/
                   yearRange: '1930:+100',
                    beforeShow: function (element) {
                        if ($(element).attr('readonly')) { return false; }
                       setTimeout(function () {
                           $('.ui-datepicker').css('z-index', 99999999999999);
                       }, 0);
                   }
               });

        $(".datePickerClicktoShow").datepicker(
           {
               /*dateFormat: 'yy-mm-dd',
               dayNames: ['Søndag', 'Mandag', 'Tirsdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lørdag'],
               dayNamesShort: ['Søn', 'Man', 'Tir', 'Ons', 'Tor', 'Fre', 'Lør'],
               dayNamesMin: ['Sø', 'Ma', 'Ti', 'On', 'To', 'Fr', 'Lø'],
               monthNames: ['Januar', 'Februar', 'Marts', 'April', 'Maj', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'December'],
               monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],*/
               /*dateFormat: 'dd-mm-yy',*/
               constrainInput: true,
               firstDay: 1,
               showWeek: true,
               changeYear: true,
               changeMonth: true,
               /*weekHeader: 'Uge',*/
               yearRange: '2013:+36',
               beforeShow: function () {
                   setTimeout(function () {
                       $('.ui-datepicker').css('z-index', 99999999999999);
                   }, 0);
               }
        });

        var dateFormat = "dd-mm-yyyy";
        var regional = $.datepicker.regional[$.datepicker.regional.bookhuscurrent];
        if (regional != null && regional != undefined) {
            dateFormat = regional.dateFormat;
        }  
              
        if($.datepicker.regional.bookhuscurrent == "da") {
            dateFormat = dateFormat.replace("yy", "åååå");
        }
        else {
            dateFormat = dateFormat.replace("yy", "yyyy");
        }
        

    $('.datePicker, .datePickerDynamic, .birthdayDatePicker, .datePickerClicktoShow').prop("placeholder", dateFormat);


    //date time picker
    const minuteInterval = 5;
    if ($.fn.datetimepicker) {
        $(".dateTimePicker").datetimepicker({
            dateFormat: 'dd-mm-yy',
            showSecond: false,
            showMillisec: false,
            showMicrosec: false,
            stepMinute: minuteInterval,
            minDateTime: roundToNearestMinuteInterval(new Date(), minuteInterval)
        });
    } else {
        console.error("datetimepicker is not loaded. Make sure the script is included.");
    }

    function roundToNearestMinuteInterval(datetime, minuteInterval) {
        return new Date(datetime.setMinutes(Math.round(datetime.getMinutes() / minuteInterval) * minuteInterval));
    }

    //}
}